import { render } from "./EditDepartment.vue?vue&type=template&id=6d3a80ea&scoped=true"
import script from "./EditDepartment.vue?vue&type=script&lang=js"
export * from "./EditDepartment.vue?vue&type=script&lang=js"

import "./EditDepartment.vue?vue&type=style&index=0&id=6d3a80ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3a80ea"]])

export default __exports__